import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { ApiService } from 'src/app/shared/api.service';
import {
    IAdvancedSearchRequest, IEventActivity, IEventSettings, IPagedResponse, IPagingOptions, ISearchEventActivitiesResponse
} from 'src/app/shared/interfaces';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
    selector: 'aza-rws-activity-list',
    templateUrl: 'activity-list.component.html',
    styleUrls: ['activity-list.component.css'],
    standalone: false
})
export class ActivityListComponent implements OnInit, OnDestroy {
    @Input() searchTextChanged: Subject<string>;
    @Input() eventSettings: IEventSettings;
    @Input() quickSearchText = '';
    @Input() showActivitiesList: Subject<void>;

    @Output() activitySelected = new EventEmitter<IEventActivity>();

    pagedResponseSubject = new Subject<IPagedResponse>();
    activitiesRes: ISearchEventActivitiesResponse = { object_count: 0, activities: [], limit: 0, offset: 0, groups: [] };
    pageSize = 10;
    pagingOptions: IPagingOptions = { offset: 0, limit: this.pageSize, object_count: 0, pageSizes: [this.pageSize] };

    private subscriptions: Subscription[] = [];

    constructor(private apiSvc: ApiService, private sharedSvc: SharedService) {
    }

    async ngOnInit(): Promise<void> {
        this.subscriptions.push(this.searchTextChanged.subscribe({
            next: searchText => this.processSearchTextChanged(searchText)
        }));
        if (this.showActivitiesList) {
            this.subscriptions.push(this.showActivitiesList.subscribe({
                next: () => this.processShowActivitiesList()
            }));
        }
    }

    private processShowActivitiesList(): void {
        this.searchActivities();
    }

    async onLikeActivity(activity: IEventActivity): Promise<void> {
        await this.apiSvc.likeActivity(activity.id);
        activity.liked = true;
    }

    async onUnlikeActivity(activity: IEventActivity): Promise<void> {
        await this.apiSvc.unlikeActivity(activity.id);
        activity.liked = false;
    }

    onClicked(activity: IEventActivity): void {
        this.activitySelected.emit(activity);
    }

    private async processSearchTextChanged(searchText: string): Promise<void> {
        this.pagingOptions.offset = 0;
        this.quickSearchText = searchText;
        await this.searchActivities();
    }

    async onPagingOffsetChanged(offset: number): Promise<void> {
        this.pagingOptions.offset = offset;
        await this.searchActivities();
    }

    private async searchActivities(): Promise<void> {
        const req: IAdvancedSearchRequest = {
            limit: this.pageSize, offset: this.pagingOptions.offset, quickSearchText: this.quickSearchText
        };
        this.activitiesRes = await this.apiSvc.searchEventActivities(req);
        this.pagingOptions = this.sharedSvc.createPagingOptionsFromPagedResponse(this.activitiesRes);
        this.pagedResponseSubject.next(this.activitiesRes);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }
}
